export default {
  allSpecies: (state) => state.species,
  speciesLoading: (state) => state.speciesLoading,
  predefinedSpeciesLoading: (state) => state.predefinedSpeciesLoading,
  predefinedSpecies: (state) => state.predefinedSpecies
}
